<template>
  <modal
    @before-close="modalClose"
    @before-open="modalOpen"
    :name="`${modal}${prefix}`"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    :width="800"
  >
    <card v-if="model">
      <div>
        <p-button class="btn mr-3" round @click.native.prevent="closeModal">
          {{ "cancel" | setText("Отмена") }}
        </p-button>

        <p-button class="btn" type="success" @click.native.prevent="accept"
          >{{ "accept" | setText("Применить") }}
        </p-button>
      </div>

      <h4>
        {{
          "select_element" | setText('Выберите элемент и нажмите "Применить"')
        }}
      </h4>
      <h6 v-if="model.isAdd === true">
        {{
          "if_not_exists_set_new"
            | setText("Если нет в списке нужного - добавьте новый")
        }}
      </h6>

      <list
        :columns="model.columns"
        :modalCreate="model.modalCreate"
        :removeLink="model.removeLink"
        :cardLink="u"
        :isUpdate="model.isUpdate"
        :params="p"
        :isAdd="model.isAdd"
        :itemLink="u"
        :setLink="u"
        :openItem="model.openItem"
        :fields="model.fields"
        :searchDisable="model.searchDisable"
        v-model="val"
        :simple="simple"
      />

      <div class="add-control">
        <div>
          <p-button class="btn" round @click.native.prevent="closeModal"
            ><span class="ti-close"> </span>
            {{ "cancel" | setText("Отмена") }}
          </p-button>

          <p-button class="btn" type="success" @click.native.prevent="accept"
            >{{ "accept" | setText("Применить") }}
          </p-button>
        </div>
      </div>
    </card>
  </modal>
</template>
<script>
import List from "../List";

export default {
  name: "ListItem",
  data() {
    return {
      val: [],
      p: {},
      u: "",
    };
  },
  props: {
    modal: {
      default: function () {
        return "";
      },
    },
    url: {
      default: function () {
        return "";
      },
    },
    params: {
      default: function () {
        return null;
      },
    },
    prefix: {
      default: function () {
        return "";
      },
    },
    simple: {
      default: false,
    },
    triggerOpen: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.$store.state.modals[this.modal];
      },
    },
  },
  created() {
    this.val = this.value;
    this.p = this.model.params ? this.model.params : this.params;

    this.u = this.url ? this.url : this.model["itemLink"];
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  components: {
    List,
  },
  methods: {
    modalClose() {},
    modalOpen() {},
    closeModal() {
      if (this.triggerOpen === true) {
        this.$notify({
          title: "Установите элемент",
          message: "Требуется сделать выбор элемента из списка",
          icon: "ti-save",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        return false;
      }

      this.$modal.hide(`${this.modal}${this.prefix}`);
    },
    accept() {
      if (this.val) {
        this.$modal.hide(`${this.modal}${this.prefix}`);
        this.$emit("input", this.val);
        this.val = [];
      }
    },
  },
};
</script>

<style lang="scss">
.add-control {
  max-width: 350px;
  width: 100%;
  position: fixed;

  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;

  div {
    // -webkit-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
    // -moz-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
    // box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
    background: rgba(#fff, 0);

    padding: 0px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    max-width: 350px;
    width: 100%;
    margin: auto;
    border-radius: 10px;

    & button {
      &:first-of-type {
        margin-right: 5px;
      }

      &:last-of-type {
        margin-left: 5px;
      }

      width: 140px;
      max-width: calc(50% - 5px);
    }
  }
}
</style>